import { useEffect, useRef } from "react";

const styles = `
  @keyframes spinCW   { from { transform: rotate(0deg); }   to { transform: rotate(360deg); } }
  @keyframes spinCCW  { from { transform: rotate(0deg); }   to { transform: rotate(-360deg); } }
  @keyframes pulseRing {
    0%, 100% { opacity: 0.1; transform: scale(1); }
    50%       { opacity: 0.45; transform: scale(1.05); }
  }
  @keyframes blink {
    0%, 100% { opacity: 0.2; }
    50%       { opacity: 1; }
  }
  @keyframes textFade {
    0%, 100% { opacity: 0.5; }
    50%       { opacity: 1; }
  }
  @keyframes sparkPulse {
    0%, 100% { opacity: 0.2; transform: scale(0.7); }
    50%       { opacity: 0.9; transform: scale(1.3); }
  }

  .dhun-spin-cw  { animation: spinCW  8s   linear infinite; transform-origin: 210px 210px; }
  .dhun-spin-ccw { animation: spinCCW 12s  linear infinite; transform-origin: 210px 210px; }
  .dhun-spin-cw2 { animation: spinCW  5.5s linear infinite; transform-origin: 210px 210px; }

  .dhun-pulse1 { animation: pulseRing 2s ease-in-out          infinite; transform-origin: 210px 210px; }
  .dhun-pulse2 { animation: pulseRing 2s ease-in-out  0.7s   infinite; transform-origin: 210px 210px; }
  .dhun-pulse3 { animation: pulseRing 2s ease-in-out  1.4s   infinite; transform-origin: 210px 210px; }

  .dhun-orb1 { animation: spinCW   6s    linear infinite; transform-origin: 210px 210px; }
  .dhun-orb2 { animation: spinCW   9.5s  linear infinite; transform-origin: 210px 210px; }
  .dhun-orb3 { animation: spinCW   7s    linear infinite; transform-origin: 210px 210px; }
  .dhun-orb4 { animation: spinCCW 11s   linear infinite; transform-origin: 210px 210px; }
  .dhun-orb5 { animation: spinCW   8s    linear infinite; transform-origin: 210px 210px; }
  .dhun-orb6 { animation: spinCCW 10.5s linear infinite; transform-origin: 210px 210px; }
  .dhun-orb7 { animation: spinCW   7s    linear reverse  infinite; transform-origin: 210px 210px; }

  .dhun-blink1 { animation: blink 1.4s ease-in-out        infinite; }
  .dhun-blink2 { animation: blink 1.4s ease-in-out 0.5s  infinite; }
  .dhun-blink3 { animation: blink 1.4s ease-in-out 1s    infinite; }
  .dhun-blink4 { animation: blink 1.4s ease-in-out 1.3s  infinite; }

  .dhun-text-fade { animation: textFade 2s ease-in-out infinite; }

  .dhun-sparkle { position: absolute; opacity: 0.7; font-size: 20px; }
  .dhun-sparkle.tl { top: 8%;  left: 5%;  animation: sparkPulse 3s ease-in-out infinite; }
  .dhun-sparkle.tr { top: 10%; right: 6%; animation: sparkPulse 3s ease-in-out 0.8s  infinite; }
  .dhun-sparkle.br { bottom: 15%; right: 4%;  animation: sparkPulse 3s ease-in-out 1.5s  infinite; }
  .dhun-sparkle.bl { bottom: 20%; left: 5%;   animation: sparkPulse 3s ease-in-out 2.2s  infinite; }
`;

export default function DhundhooLoader() {
  const styleRef = useRef(null);

  useEffect(() => {
    const tag = document.createElement("style");
    tag.textContent = styles;
    document.head.appendChild(tag);
    styleRef.current = tag;
    return () => document.head.removeChild(tag);
  }, []);

  return (
    <div
      style={{
        // background:
        //   "radial-gradient(ellipse at 50% 40%, #ffffff 0%, #fff8ee 50%, #fdf3e3 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        fontFamily: "'Courier New', monospace",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Dot grid background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "radial-gradient(circle, rgba(200,120,0,0.07) 1px, transparent 1px)",
          backgroundSize: "38px 38px",
          zIndex: 0,
        }}
      />
 

      {/* Main scene */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 28,
        }}
      >
        <div style={{ position: "relative", width: 420, height: 420 }}>
          <svg
            width="420"
            height="420"
            viewBox="0 0 420 420"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <filter id="glowOrange" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="4" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
              <filter id="glowPurple" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="5" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
              <filter id="glowStrong" x="-80%" y="-80%" width="260%" height="260%">
                <feGaussianBlur stdDeviation="8" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
              <linearGradient id="ringGradOrange" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%"   stopColor="#f5a623" stopOpacity="1" />
                <stop offset="50%"  stopColor="#e07800" stopOpacity="0.35" />
                <stop offset="100%" stopColor="#f5a623" stopOpacity="1" />
              </linearGradient>
              <linearGradient id="ringGradPurple" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%"   stopColor="#7b3fa0" stopOpacity="1" />
                <stop offset="50%"  stopColor="#5a2d82" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#7b3fa0" stopOpacity="1" />
              </linearGradient>
              <radialGradient id="centerBg" cx="50%" cy="40%" r="60%">
                <stop offset="0%"   stopColor="#ffffff" />
                <stop offset="100%" stopColor="#fdf3e3" />
              </radialGradient>
            </defs>

            {/* Pulse rings */}
            <circle cx="210" cy="210" r="178" fill="none" stroke="#f5a623" strokeWidth="1"   className="dhun-pulse1" opacity="0.15" />
            <circle cx="210" cy="210" r="165" fill="none" stroke="#7b3fa0" strokeWidth="0.8" className="dhun-pulse2" opacity="0.12" />
            <circle cx="210" cy="210" r="155" fill="none" stroke="#f5a623" strokeWidth="0.6" className="dhun-pulse3" opacity="0.1"  />

            {/* Spinning dashed orbit tracks */}
            <g className="dhun-spin-cw">
              <circle cx="210" cy="210" r="135" fill="none" stroke="#f5a623" strokeWidth="1.3"
                strokeDasharray="9 11" opacity="0.45" filter="url(#glowOrange)" />
            </g>
            <g className="dhun-spin-ccw">
              <circle cx="210" cy="210" r="100" fill="none" stroke="#7b3fa0" strokeWidth="1.3"
                strokeDasharray="6 9" opacity="0.45" filter="url(#glowPurple)" />
            </g>
            <g className="dhun-spin-cw2">
              <circle cx="210" cy="210" r="65" fill="none" stroke="#f5a623" strokeWidth="1"
                strokeDasharray="3 6" opacity="0.3" />
            </g>

            {/* Glowing neon rings */}
            <g filter="url(#glowStrong)">
              <circle cx="210" cy="210" r="148" fill="none" stroke="url(#ringGradOrange)" strokeWidth="3.5" opacity="0.9" />
            </g>
            <g filter="url(#glowOrange)">
              <circle cx="210" cy="210" r="140" fill="none" stroke="#f5a623" strokeWidth="1.2" opacity="0.55" />
            </g>
            <g filter="url(#glowStrong)">
              <circle cx="210" cy="210" r="112" fill="none" stroke="url(#ringGradPurple)" strokeWidth="3"   opacity="0.85" />
            </g>
            <g filter="url(#glowPurple)">
              <circle cx="210" cy="210" r="105" fill="none" stroke="#5a2d82"               strokeWidth="1.1" opacity="0.5"  />
            </g>

            {/* ── OUTER ORBIT ICONS (r=135) ── */}

            {/* 1 · GPS Satellite */}
            <g className="dhun-orb1">
              <g transform="translate(210,75)">
                <circle cx="0" cy="0" r="30" fill="#fffaf4" stroke="#f5a623" strokeWidth="2.2" filter="url(#glowOrange)" />
                <path d="M-17,-10 A21,21 0 0 1 17,-10" fill="none" stroke="#f5a623" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
                <path d="M-11,-4 A13,13 0 0 1 11,-4" fill="none" stroke="#f5a623" strokeWidth="1.5" strokeLinecap="round" opacity="0.9" />
                <rect x="-9" y="-7" width="18" height="11" rx="2" fill="#7b3fa0" />
                <rect x="-5" y="-5" width="4"  height="7"  rx="1" fill="#ffe0b0" />
                <rect x="1"  y="-5" width="4"  height="7"  rx="1" fill="#ffe0b0" />
                <rect x="-22" y="-4" width="11" height="5.5" rx="1.5" fill="#f5a623" stroke="#c07000" strokeWidth="0.8" />
                <rect x="11"  y="-4" width="11" height="5.5" rx="1.5" fill="#f5a623" stroke="#c07000" strokeWidth="0.8" />
                <line x1="-11" y1="-1.5" x2="-22" y2="-1.5" stroke="#c07000" strokeWidth="0.8" />
                <line x1="11"  y1="-1.5" x2="22"  y2="-1.5" stroke="#c07000" strokeWidth="0.8" />
                <ellipse cx="0" cy="8" rx="4.5" ry="2.5" fill="#7b3fa0" opacity="0.8" />
                <text x="0" y="26" textAnchor="middle" fontSize="7.5" fontWeight="800"
                  fill="#7b3fa0" fontFamily="'Courier New',monospace" letterSpacing="1">GPS</text>
              </g>
            </g>

            {/* 2 · Truck */}
            <g className="dhun-orb2">
              <g transform="translate(210,75)">
                <circle cx="0" cy="0" r="26" fill="#fffaf4" stroke="#f5a623" strokeWidth="2" filter="url(#glowOrange)" />
                <rect x="-18" y="-7" width="22" height="11" rx="1.5" fill="#f5a623" />
                <rect x="4"   y="-12" width="14" height="16" rx="2"   fill="#e07800" />
                <rect x="7"   y="-10" width="8"  height="5"  rx="1"   fill="#fffaf4" opacity="0.85" />
                <circle cx="-12" cy="6" r="3.8" fill="#5a2d82" stroke="#7b3fa0" strokeWidth="1" />
                <circle cx="3"   cy="6" r="3.8" fill="#5a2d82" stroke="#7b3fa0" strokeWidth="1" />
                <circle cx="14"  cy="6" r="3.8" fill="#5a2d82" stroke="#7b3fa0" strokeWidth="1" />
                <line x1="-23" y1="-3" x2="-18" y2="-3" stroke="#e07800" strokeWidth="1.5" strokeLinecap="round" opacity="0.9" />
                <line x1="-25" y1="1"  x2="-18" y2="1"  stroke="#e07800" strokeWidth="1"   strokeLinecap="round" opacity="0.55" />
              </g>
            </g>

            {/* 3 · Route Check */}
            <g className="dhun-orb3">
              <g transform="translate(210,75)">
                <circle cx="0" cy="0" r="24" fill="#fffaf4" stroke="#7b3fa0" strokeWidth="2" filter="url(#glowPurple)" />
                <circle cx="-10" cy="6"  r="4"   fill="#7b3fa0" filter="url(#glowPurple)" />
                <circle cx="-3"  cy="-4" r="2.5" fill="#5a2d82" opacity="0.6" />
                <circle cx="4"   cy="-8" r="2.5" fill="#5a2d82" opacity="0.6" />
                <circle cx="10"  cy="-2" r="4"   fill="#7b3fa0" filter="url(#glowPurple)" />
                <path d="M-10,6 C-5,-1 2,-6 10,-2" fill="none" stroke="#7b3fa0" strokeWidth="1.5" strokeDasharray="3 2" opacity="0.9" />
                <circle cx="10" cy="-12" r="5" fill="none" stroke="#f5a623" strokeWidth="1.5" />
                <path d="M7,-12 L9.5,-9.5 L13,-14" fill="none" stroke="#f5a623" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </g>
            </g>

            {/* 4 · Stop Board */}
            <g className="dhun-orb4">
              <g transform="translate(210,75)">
                <circle cx="0" cy="0" r="28" fill="#fffaf4" stroke="#7b3fa0" strokeWidth="1.8" />
                <rect x="-2" y="12" width="4" height="12" rx="1" fill="#c07000" />
                <rect x="-20" y="-12" width="40" height="26" rx="3" fill="#5a2d82" stroke="#7b3fa0" strokeWidth="1.5" />
                <text x="0" y="-1" textAnchor="middle" fontSize="8" fontWeight="900"
                  fill="#f5a623" fontFamily="'Courier New',monospace" letterSpacing="1">STOP</text>
                <text x="0" y="10" textAnchor="middle" fontSize="11" fontWeight="900"
                  fill="#ffffff" fontFamily="Arial,sans-serif">4</text>
              </g>
            </g>

            {/* ── MID ORBIT ICONS (r=100) ── */}

            {/* 5 · Map Pin */}
            <g className="dhun-orb5">
              <g transform="translate(210,110)">
                <circle cx="0" cy="0" r="22" fill="#fffaf4" stroke="#f5a623" strokeWidth="1.8" filter="url(#glowOrange)" />
                <ellipse cx="0" cy="16" rx="5" ry="2" fill="#e0c080" opacity="0.35" />
                <path d="M0,-14 C-8,-14 -13,-8 -13,-1 C-13,9 0,20 0,20 C0,20 13,9 13,-1 C13,-8 8,-14 0,-14Z"
                  fill="#f5a623" filter="url(#glowOrange)" />
                <circle cx="0" cy="-2" r="5"   fill="#fffaf4" />
                <circle cx="0" cy="-2" r="2.5" fill="#7b3fa0" opacity="0.9" />
              </g>
            </g>

            {/* 6 · Car */}
            <g className="dhun-orb6">
              <g transform="translate(210,110)">
                <circle cx="0" cy="0" r="22" fill="#fffaf4" stroke="#f5a623" strokeWidth="1.5" filter="url(#glowOrange)" />
                <rect x="-13" y="-3" width="26" height="8" rx="2.5" fill="#f5a623" />
                <path d="M-7,-3 L-9,-9 L9,-9 L7,-3 Z" fill="#e07800" />
                <rect x="-7" y="-8" width="5" height="4" rx="0.5" fill="#fffaf4" opacity="0.85" />
                <rect x="2"  y="-8" width="5" height="4" rx="0.5" fill="#fffaf4" opacity="0.85" />
                <circle cx="-7" cy="7" r="3.5" fill="#5a2d82" stroke="#7b3fa0" strokeWidth="1" />
                <circle cx="7"  cy="7" r="3.5" fill="#5a2d82" stroke="#7b3fa0" strokeWidth="1" />
              </g>
            </g>

            {/* 7 · Mini Car (reverse) */}
            <g className="dhun-orb7">
              <g transform="translate(210,310)">
                <circle cx="0" cy="0" r="20" fill="#fffaf4" stroke="#7b3fa0" strokeWidth="1.3" filter="url(#glowPurple)" />
                <rect x="-12" y="-2" width="24" height="8" rx="2" fill="#7b3fa0" />
                <path d="M-6,-2 L-8,-8 L8,-8 L6,-2 Z" fill="#5a2d82" />
                <rect x="-6" y="-7" width="4" height="4" rx="0.5" fill="#ffe0b0" opacity="0.8" />
                <rect x="2"  y="-7" width="4" height="4" rx="0.5" fill="#ffe0b0" opacity="0.8" />
                <circle cx="-6" cy="7" r="3" fill="#f5a623" stroke="#c07000" strokeWidth="0.8" />
                <circle cx="6"  cy="7" r="3" fill="#f5a623" stroke="#c07000" strokeWidth="0.8" />
              </g>
            </g>

            {/* Blinking coordinate dots */}
            <circle cx="210" cy="145" r="5.5" fill="#f5a623" className="dhun-blink1" filter="url(#glowOrange)" />
            <circle cx="275" cy="210" r="5.5" fill="#7b3fa0" className="dhun-blink2" filter="url(#glowPurple)" />
            <circle cx="210" cy="275" r="5.5" fill="#f5a623" className="dhun-blink3" filter="url(#glowOrange)" />
            <circle cx="145" cy="210" r="5.5" fill="#7b3fa0" className="dhun-blink4" filter="url(#glowPurple)" />

            {/* Center circle */}
            <circle cx="210" cy="210" r="95" fill="url(#centerBg)" stroke="#f0dfc0" strokeWidth="2.5" />
            <circle cx="210" cy="210" r="85" fill="white"          stroke="#edd9a3" strokeWidth="1.5" opacity="0.9" />
            <circle cx="210" cy="210" r="76" fill="none"           stroke="#f0d090" strokeWidth="1"
              strokeDasharray="4 3" opacity="0.6" />

            {/* Crosshair ticks */}
            <line x1="210" y1="136" x2="210" y2="150" stroke="#7b3fa0" strokeWidth="2.2" strokeLinecap="round" opacity="0.55" />
            <line x1="210" y1="270" x2="210" y2="284" stroke="#7b3fa0" strokeWidth="2.2" strokeLinecap="round" opacity="0.55" />
            <line x1="136" y1="210" x2="150" y2="210" stroke="#7b3fa0" strokeWidth="2.2" strokeLinecap="round" opacity="0.55" />
            <line x1="270" y1="210" x2="284" y2="210" stroke="#7b3fa0" strokeWidth="2.2" strokeLinecap="round" opacity="0.55" />

            {/* Center logo */}
            <image
              href="https://next-web.dhundhoo.com/dhundhoo_logo.png"
              x="135" y="160"
              width="150" height="100"
              preserveAspectRatio="xMidYMid meet"
            />
          </svg>
        </div>

        {/* Bottom text */}
        <div style={{ textAlign: "center" }}>
          <div
            className="dhun-text-fade"
            style={{
              color: "#5a2d82",
              fontSize: 21,
              fontWeight: 800,
              letterSpacing: 6,
              textTransform: "uppercase",
            }}
          >
            LOADING...
          </div>
          <div
            style={{
              color: "#c07000",
              fontSize: 10,
              letterSpacing: 3,
              textTransform: "uppercase",
              marginTop: 6,
            }}
          >
            DHUNDHOO TRACKING &nbsp;—&nbsp; MONITORING INITIATED
          </div>
        </div>
      </div>
    </div>
  );
}